module.exports = __webpack_public_path__ + "img/collage_img_02.a756cff7.jpg";